import './functions';
import './logic';
import './reducers';
import './render';
import './statics';
import './variables';
import { wrapperBuilder } from './build';

export const ChatWrapper = wrapperBuilder.build();
